import React from 'react';
import {Form, Header, Loader, Responsive, Segment, Tab} from 'semantic-ui-react';
import axios from 'axios';
import moment from "moment";
import NewExamByTerm from "./NewExamByTerm";
import ExamsByTerm from "./ExamsByTerm";
import {string} from "prop-types";
import {fetchAcademicYears, fetchCurrentAcademicYear} from "../../Lookups/util";

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


export default class CreateExams extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            examTerms:[],
            examTerm:'',
            academicYears: [],
            academicYear: '',
            courses: [],
            activeIndex:0
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getTerms = this.getTerms.bind(this);
    }

    componentDidMount() {
        window.localStorage.removeItem('examTermName');
        window.localStorage.removeItem('academicYear');

        axios.all([fetchAcademicYears(), fetchCurrentAcademicYear()])
            .then(axios.spread((res, resCurrent) => {
                const academicYears = res.data.reverse().map((el, index) => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));

                this.setState({ academicYears });


                    this.setState({ academicYear: resCurrent.data.id });
                    localStorage.setItem('academicYear', resCurrent.data.id);
                    this.getTerms(resCurrent.data.id);

            }))
            .catch(err => {
                console.log('Failed to fetch academic years');
            });



        //disabled academic year dropdown, get implementation and gard for current academic year

    }

    getTerms (academicYear) {
        axios.get(`/exams/gard-by-academic-year/${academicYear}/`)
            .then(res => {
                const examTerms = res.data.map(el => ({
                    ...el,
                    text: el.name + ' (' + moment(el.startDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.') + ')',
                    value: el.id + 1,
                    key: el.id + 1
                }));
                this.setState({examTerms})
            })
            .catch(err => {
                console.log('Failed to fetch exam terms...');
            });

        let academicYearObj = {};
        let academicYearId = academicYear;
        academicYearObj = { ...academicYear, academicYearId };

        axios.get('course/filter-implementations/', { params: academicYearObj })
            .then(res => {
                this.setState({
                    courses: res.data.map(el => ({
                        text: el.code ? el.courseBasic.name + ' | ' + el.code + ' | ' + el.semesters[0].name.name
                            : el.courseBasic.name + ' | ' + el.semesters[0].name.name,
                        value: el.id,
                        key: el.id,
                        description: el.courseBasic.comment,
                        courseBasicId: el.courseBasic.id
                    }))
                });
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }



    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value, activeIndex: 0
        });
        if(name==='examTerm'){
            localStorage.setItem('examTermName', this.state.examTerms.find(el=>el.value === value).text);
        }

        if(name === 'academicYear'){
            localStorage.setItem('academicYear', value);
            this.setState({ examTerm : null, examTerms: [] })

            axios.get(`/exams/gard-by-academic-year/${value}/`)
                .then(res => {
                    const examTerms = res.data.map(el => ({
                        ...el,
                        text: el.name + ' (' + moment(el.startDate).format('D. M. YYYY.') + ' - ' + moment(el.endDate).format('D. M. YYYY.') + ')',
                        value: el.id + 1,
                        key: el.id + 1
                    }));
                    this.setState({examTerms})
                })
                .catch(err => {
                    console.log('Failed to fetch exam terms...');
                });

            let academicYear = {};
            let academicYearId = localStorage.getItem('academicYear');
            academicYear = { ...academicYear, academicYearId };
            axios.get('course/filter-implementations/', { params: academicYear })
                .then(res => {
                    this.setState({
                        courses: res.data.map(el => ({
                            text: el.code ? el.courseBasic.name + ' | ' + el.code + ' | ' + el.semesters[0].name.name
                                : el.courseBasic.name + ' | ' + el.semesters[0].name.name,
                            value: el.id,
                            key: el.id,
                            description: el.courseBasic.comment,
                            courseBasicId: el.courseBasic.id
                        }))
                    });
                })
                .catch(err => {
                    console.log('Failed to fetch courses');
                });
        }
    }

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })

    render() {
        const panes = [
            {
                menuItem: 'Kreiranje ispita',
                render: () => (<Tab.Pane as={Responsive}>
                        <NewExamByTerm
                            examTerm={this.state.examTerm}
                            showForm={this.state.examTerm && this.state.academicYear}
                            endDate={this.state.examTerm && this.state.examTerms.find(el => el.value === this.state.examTerm).endDate}
                            startDate={this.state.examTerm && this.state.examTerms.find(el => el.value === this.state.examTerm).startDate}
                            courses={this.state.courses}
                        />

                </Tab.Pane>)
            },
            {
                menuItem: 'Prikaz ispita na roku',
                render: () => (<Tab.Pane as={Responsive}>
                    <ExamsByTerm
                        id={this.state.examTerm-1}
                        name= {localStorage.getItem('examTermName')}
                    />

                </Tab.Pane>)
            }
        ];
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <Header as="h1"> Kreiranje i prikaz ispita po rokovima </Header>
                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {localStorage.getItem('examTermName')}
                            <Header.Subheader>
                                Ispitni rok
                            </Header.Subheader>
                        </Header>
                    </Segment>

                        <Segment clearing>
                            <br/>
                            <Form noValidate>
                                <Form.Group widths="equal" >
                                    <Form.Field required>
                                        <label>Akademska godina</label>
                                        <Form.Dropdown
                                            placeholder="Odaberite akademsku godinu"
                                            value={parseInt(this.state.academicYear)}
                                            onChange={this.handleInputChange}
                                            name="academicYear"
                                            options={this.state.academicYears}
                                            search
                                            fluid
                                            selection
                                        />
                                    </Form.Field>
                                    <Form.Field required error={this.state.examTermErr} disabled={!this.state.academicYear}>
                                        <label>Ispitni rok</label>
                                        <Form.Dropdown
                                            selection
                                            placeholder="Odaberite ispitni rok"
                                            value={this.state.examTerm}
                                            onChange={this.handleInputChange}
                                            name="examTerm"
                                            options={this.state.examTerms}
                                            search
                                            fluid
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                   <br/>
                   <br/>

                            {this.state.examTerm && <Tab
                                menu={{ secondary: true, pointing: true, color: 'blue' }}
                                panes={panes}
                                activeIndex={this.state.activeIndex}
                                onTabChange={this.handleTabChange} />}
                        </Segment>

                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/CreateExams.js